import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Button, Divider, Form, Input, InputNumber, Modal } from 'antd';
import styles from './Register.module.scss';
import { useNavigate } from 'react-router-dom';
import { useGlobalLoading } from 'hooks';
import { AuthService } from 'services';
import smallLogo from 'assets/images/allin1logoNoText.png';
import logo from 'assets/images/logo.png';
import { CFCDN } from 'modules/shop-front/shop-front-component/ProductCollection';
import { CloseOutlined } from '@ant-design/icons';
import { useAuthModalStore } from 'modules/zustand/store';
/* eslint-disable */
interface RegisterFormProps {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
}

interface RegisterData {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
}

const RegisterModal: FC = (): ReactElement => {
  const { showLoading, hideLoading } = useGlobalLoading();
  const navigate = useNavigate();
  const [form] = Form.useForm<RegisterFormProps>();
  const [formError, setFormError] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [registerApiError, setRegisterApiError] = useState<{
    error_code: string;
    error_message: string;
  }>();
  const first_name = Form.useWatch('first_name', form);
  const last_name = Form.useWatch('last_name', form);
  const email = Form.useWatch('email', form);
  const [phone, setPhone] = useState<string>('');
  const setOffRegisterModal = useAuthModalStore((state)=>state.setOffRegisterModal)
  const setOnLoginModal = useAuthModalStore((state)=>state.setOnLoginModal)

  useEffect(() => {
    setFormError(registerApiError?.error_message || '');
  }, [registerApiError]);

  const onFinish = (value: RegisterFormProps) => {
    showLoading();
    const { first_name, last_name, email, phone } = value;
    fetchRegister(value).finally(hideLoading);
  };

  const fetchRegister = async (value: RegisterData) => {
    // call API
    
    try {
        const data = await AuthService.register(
            first_name,
            last_name,
            email,
            phone,
        );
        setIsModalOpen(true);
        setOffRegisterModal();
    } catch (e: any) {
      if (
        e.error_code === 'INVALID_CREDENTIAL' ||
        e.error_code === 'EMAIL_EXISTED'
      ) {
        setRegisterApiError(e);
      } else if (e.error_code === 'INTERNAL_SERVER')
        setFormError('Invalid email');
      else {
        setRegisterApiError(undefined);
      }
    }
  };

  const onClickRegister = (e: any) => {
    e.preventDefault();
    // Do action submit if form pass validate fields
    form.validateFields().then(form.submit).catch(getError);
  };

  const getError = () => {
    const errors = form
      .getFieldsError()
      .map((item) => item.errors)
      .reduce((prev, cur) => {
        return prev.concat(cur);
      }, []);
    setFormError(errors[0]);
  };

  const onChangeData = () => {
    const phone = form.getFieldsValue().phone;
    if (phone) {
      const phonePlus = '+61' + phone;
      setPhone(phonePlus);
    }
  };

  return (
    
    <div className="flex flex-col justify-center items-center my-2 gap-3">
     
    
      <img style={{maxHeight:'70px'}} src={smallLogo} onClick={()=>(navigate('/'))} />
      <h1>Register</h1>
      <Form
        form={form}
        name="basic"
        className="flex flex-col"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        layout={'vertical'}
        size={'middle'}
        autoComplete="off"
      >
        {formError && (
          <div className="flex justify-center items-center bg-[#FFE0E0] h-[40px] mb-5">
            {formError}
          </div>
        )}
        {/* First Name */}
        <label htmlFor="first_name" className={styles['form-item-label']}>
          First Name: <span className="text-red-600">*</span>
        </label>
        <Form.Item
          className={styles['form-item']}
          name="first_name"
          rules={[
            { required: true, message: 'Please input your First Name!' },
            { min: 3, message: 'Username must be minimum 3 characters.' },
            { whitespace: true },
          ]}
          // validateTrigger={false}
          hasFeedback
        >
          <Input
            type="name"
            id="first_name"
            onChange={onChangeData}
            className={`!w-[300px] h-[40px] !rounded-md ${
              registerApiError ? '!border-red-500' : ''
            }`}
          />
        </Form.Item>
        {/* Last Name */}
        <label htmlFor="last_name" className={styles['form-item-label']}>
          Last Name: <span className="text-red-600">*</span>
        </label>
        <Form.Item
          className={styles['form-item']}
          name="last_name"
          rules={[
            { required: true, message: 'Please input your Last Name!' },
            { min: 3, message: 'Username must be minimum 5 characters.' },
            { whitespace: true },
          ]}
          // validateTrigger={false}
          hasFeedback
        >
          <Input
            type="name"
            id="last_name"
            onChange={onChangeData}
            className={`!w-[300px] h-[40px] !rounded-md ${
              registerApiError ? '!border-red-500' : ''
            }`}
          />
        </Form.Item>
        {/* Email */}
        <label htmlFor="email" className={styles['form-item-label']}>
          Email: <span className="text-red-600">*</span>
        </label>
        <Form.Item
          className={styles['form-item']}
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please input a valid email!' },
          ]}
          // validateTrigger={false}
          hasFeedback
        >
          <Input
            type="email"
            id="email"
            onChange={onChangeData}
            className={`!w-[300px] h-[40px] !rounded-md ${
              registerApiError ? '!border-red-500' : ''
            }`}
          />
        </Form.Item>
        {/* Phone */}
        <label htmlFor="phone" className={styles['form-item-label']}>
          Phone: <span className="text-red-600">*</span>
        </label>
        <Form.Item
          className={styles['form-item']}
          name="phone"
          rules={[{ required: true, message: 'Please input your Phone!' }]}
          validateTrigger={false}
        >
          <InputNumber
            addonBefore="+61"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            }
            id="phone"
            maxLength={11}
            onChange={onChangeData}
            className="!w-[300px] h-[40px] !rounded-md"
          />
        </Form.Item>
        {/* Register */}
        <Form.Item className={styles['form-item']}>
          <button
            className="w-full flex justify-center items-center shadow mt-3 border-none text-white bg-black hover:bg-neutral-200 hover:text-black hover:shadow-md font-[450] rounded-lg text-xl py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300"
            onClick={onClickRegister}
          >
            Sign Up
          </button>
        </Form.Item>


        <div className=" text-black text-lg m-auto">Already have an account?</div>
        <Form.Item className={styles['form-item']}>
          <button
            className="w-full flex justify-center items-center shadow mt-3 border-none text-black bg-neutral-200 hover:bg-neutral-300 hover:shadow-md font-[450] rounded-lg text-xl px-5 py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300" 
            style={{height:'40px'}}
            onClick={() => {setOffRegisterModal();setOnLoginModal();}}
          >
            Login
          </button>
        </Form.Item>
        
            {/* Modal confirm */}
            <Modal
            //title={<img className="m-auto" style={{maxHeight:'45px'}} src={smallLogo} />}
            cancelButtonProps={{ style: { display: 'none' } }}
            open={isModalOpen}
            centered
            width={500}
            onCancel={()=>{setIsModalOpen(false)}}
            footer={null}
            // onOk={() => navigate('/login')}
            >
                <div className="text-center">
                <div className="flex" style={{margin:'15px'}}>
                    <img className="m-auto" style={{maxHeight:'80px'}} src={smallLogo} />
                </div>
                    <span className="block font-semibold text-xl">
                    Please check your email to set your password and complete the sign-up process.
                    </span>
                </div>
            </Modal>
        </Form>
        </div>
       
  

  );
};

export default RegisterModal;
